import { createContext, useContext } from 'react';

import { useGlobalVariables } from '../../context/globalConfig/securedConfigHook';
import { useUser } from '../../context/user';

/**
 * When set to `true` by an ancestor provider, forces {@link useIsCopilotEnabled} to return `false`
 * regardless of global / user settings. Use this to hide Copilot affordances in flows where the
 * Copilot backend is not wired up (e.g. the harmonization onboarding flow), so users don't see
 * buttons that do nothing when clicked.
 */
const CopilotForceDisabledContext = createContext<boolean>(false);

export function CopilotForceDisabledProvider({ children, value }: { children: React.ReactNode; value: boolean }) {
  return <CopilotForceDisabledContext.Provider value={value}>{children}</CopilotForceDisabledContext.Provider>;
}

export function useIsCopilotEnabled() {
  const forceDisabled = useContext(CopilotForceDisabledContext);
  const userData = useUser();
  const isCopilotEnabled = useGlobalVariables().isClusterLevelCopilotEnabled && !!userData?.user?.copilotEnabled;

  return !forceDisabled && isCopilotEnabled;
}
